import { useMemo } from 'react';
import type React from 'react';
import {
  Datagrid,
  FunctionField,
  List,
} from 'react-admin';
import { Button, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';

export const ReportsDataGrid = () => {
  // Default sort: title descending (which naturally sorts by date DESC, then number DESC)
  const sort = useMemo(
    () => ({ field: 'title', order: 'DESC' as const }),
    [],
  );

  return (
    <List resource="reports" perPage={25} sort={sort}>
      <Datagrid bulkActionButtons={false}>
        <FunctionField
          label="Actions"
          render={(record: any) => <ViewButton record={record} />}
        />
        <FunctionField
          label="Title"
          render={(record: any) => <TitleLink record={record} />}
          sortable
        />
      </Datagrid>
    </List>
  );
};

const ViewButton = ({ record }: { record: any }) => {
  const navigate = useNavigate();

  const handleView = () => {
    // Navigate to the dialog view with the report folder path
    navigate(`/reports/view/${encodeURIComponent(record.path)}`);
  };

  return (
    <Button
      size="small"
      startIcon={<VisibilityIcon />}
      onClick={handleView}
      variant="outlined"
    >
      View
    </Button>
  );
};

const TitleLink = ({ record }: { record: any }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Navigate to the dialog view with the report folder path
    navigate(`/reports/view/${encodeURIComponent(record.path)}`);
  };

  return (
    <Link
      component="button"
      onClick={handleClick}
      sx={{
        textDecoration: 'none',
        color: 'primary.main',
        '&:hover': {
          textDecoration: 'underline',
        },
        cursor: 'pointer',
      }}
    >
      {record.title}
    </Link>
  );
};

